import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "chat.title",
    defaultMessage: "Chat",
    description: "Heading for chat card in meeting session view",
  },
  description: {
    id: "chat.description",
    defaultMessage: "The messages you write are visible to all participants.",
    description: "Text to be shown when no chat messages",
  },
  generalError: {
    id: "chat.error.could.not.load.chat",
    defaultMessage: "Something went wrong",
    description: "Text shown in snack bar when it fails to load chat message",
  },
});
